"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useV1CreateTeam = void 0;
const api_1 = require("core/api");
const useExperiments_1 = require("hooks/useExperiments");
const React = __importStar(require("react"));
const useNavigation_1 = require("src/hooks/useNavigation");
const useRequest_1 = require("src/hooks/useRequest");
const timezone_mapping_1 = require("utils/timezone-mapping");
const validation_signup_1 = require("utils/validation-signup");
const defaultTrialTeam = {
    teamName: '',
    sport: '',
    teamAge: '',
    postalCode: '',
    country: '',
    timezone: '',
};
const useV1CreateTeam = () => {
    const { navigate, getState } = (0, useNavigation_1.useNavigation)();
    const isSignup = getState('isSignup');
    const [trialTeam, setTrialTeam] = React.useState(defaultTrialTeam);
    const [setupConfig, setSetupConfig] = React.useState(); // eslint-disable-line @typescript-eslint/no-unused-vars
    const experiments = (0, useExperiments_1.useExperiments)();
    const [errors, setErrors] = React.useState({});
    const { isProcessing, makeRequest } = (0, useRequest_1.useRequest)();
    const newPricingPage = experiments[useExperiments_1.EXPERIMENT_IDS.NEW_PRICING_PAGE];
    const forwardToNewPricingPage = newPricingPage
        ? Boolean(newPricingPage?.isEnabled && newPricingPage?.hasAccess)
        : false;
    const setDefaultTimezone = (timezones) => {
        const browserOptions = Intl.DateTimeFormat().resolvedOptions();
        const userTz = browserOptions.timeZone;
        const locale = browserOptions.locale;
        if (timezones && userTz) {
            const defaultTz = timezones.find((t) => t.description === userTz);
            setTrialTeam((prev) => ({
                ...prev,
                timezone: defaultTz ? (0, timezone_mapping_1.getRailsTimezone)(defaultTz.description) : '',
            }));
        }
        if (locale && locale.includes('US')) {
            setTrialTeam((prev) => ({
                ...prev,
                country: 'United States',
            }));
        }
        if (locale && locale.includes('CA')) {
            setTrialTeam((prev) => ({
                ...prev,
                country: 'Canada',
            }));
        }
    };
    const loadSetupConfig = async () => {
        const setup = await api_1.TeamSetupService.getSetupConfig();
        setup && setSetupConfig(setup);
        setup?.timezones && setDefaultTimezone(setup.timezones);
    };
    React.useEffect(() => {
        loadSetupConfig();
    }, []);
    const submitTeam = async () => {
        const postalCodeRequired = (0, validation_signup_1.requirePostalCode)(trialTeam.country);
        // validate fields
        const er = (0, validation_signup_1.validateSignupFields)(trialTeam, [
            ...['teamName', 'sport', 'country', 'timezone', 'teamAge'],
            ...(postalCodeRequired ? ['postalCode'] : []),
        ]);
        if (Object.keys(er).length > 0) {
            setErrors(er);
            return;
        }
        const teamResponse = await makeRequest(() => api_1.TeamService.createTeam({
            name: trialTeam.teamName,
            sportId: +trialTeam.sport,
            postalCode: postalCodeRequired ? trialTeam.postalCode : undefined,
            ageGroup: trialTeam.teamAge,
            country: trialTeam.country,
            timeZone: trialTeam.timezone,
        }));
        if (teamResponse?.data?.id) {
            const teamId = teamResponse.data.id.toString();
            if (forwardToNewPricingPage) {
                const urlParams = new URLSearchParams(window.location.search);
                navigate.v1TeamPlanNew(teamId, undefined, urlParams.toString());
            }
            else {
                navigate.v1TeamPlan(teamId);
            }
        }
    };
    return {
        trialTeam,
        setupConfig,
        errors,
        isProcessing,
        setTeam: (key, value) => {
            setErrors({ ...errors, [key]: undefined });
            setTrialTeam((prev) => ({
                ...prev,
                [key]: value,
            }));
        },
        submitTeam,
        isSignup,
    };
};
exports.useV1CreateTeam = useV1CreateTeam;
